export default __webpack_public_path__ + "static/media/Vol4Issue4.9e3623ce.png";